import { useMutation, useQueryClient } from '@tanstack/react-query';
import { isArray } from 'lodash';

import postPresenceClockIn from 'Api/monitoring/postPresenceClockIn';
import { useLoader } from 'Store/loader';
import { useToast } from 'Store/toast';
import generateDeviceId from 'Helper/generateDeviceId';

import postPresenceClockInPayload from './model/request/postPresenceClockInPayload';
import postPresenceClockInResponse from './model/response/postPresenceClockInResponse';
import { postPresenceClockInText } from 'Const/monitoring/domain';

const usePostPresenceClockIn = () => {
  const { onShowLoader, onResetLoader } = useLoader();
  const { onOpenToast } = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (formData) => {
      onShowLoader({ variant: 'loader-primary' });

      const deviceId = generateDeviceId();

      const payload = postPresenceClockInPayload({ ...formData, deviceId });

      const response = await postPresenceClockIn(payload);

      const result = postPresenceClockInResponse({ response, deviceId });

      return result;
    },
    onSuccess: (response) => {
      const isViolation = response?.operatorPresence?.isViolatedClockIn;
      const time = response?.operatorPresence?.clockInTime;

      queryClient.invalidateQueries({ queryKey: ['monitoring-operator-status'] });

      if (isViolation) {
        const description = postPresenceClockInText.getLatePresenceClockIn(time);

        return onOpenToast({
          status: 'error',
          description,
          duration: 5,
          alwaysShow: false,
        });
      }

      const description = postPresenceClockInText.getOnTimePresenceClockInText(time);

      return onOpenToast({ status: 'success', description, duration: 5, alwaysShow: false });
    },
    onError: (error) => {
      console.log(error);
      const errorMessage = isArray(error?.response?.data?.errors) ? error?.response?.data?.errors[0]?.message : postPresenceClockInText.defaultErrorMessageText;

      onOpenToast({ status: 'error', description: errorMessage, duration: 5, alwaysShow: false });
    },
    onSettled: () => onResetLoader(),
  });
};

export default usePostPresenceClockIn;
